export enum PendingTransactionRule {
    FutureCycleFill
}